export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "ЭПК: Список проектов описей дел",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
